import { Injectable } from '@angular/core';
import { SecureApi } from '../../../../core/secure.api';

@Injectable()
export class PackageBillingService {
    url = 'b2c-patients/billings';

    constructor(public secureApi: SecureApi) { }

    getAll(filters) {
        let queryParams = filters;
        return this.secureApi.get(this.url + '/index?' + queryParams);
    }

    search(term: string, roleId: number, clinicId: number) {
        return this.secureApi.get('users/search/' + term + '?role_id=' + roleId + '&clinic_id=' + clinicId)['items'];
    }

    export(filters) {
        let queryParams = filters;
        return this.secureApi.get(this.url + '/export?' + queryParams);
    }
}